<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon color="white" class="info-icon mr-2">mdi-information</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Requerimiento Adicional en Proyecto</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="startCloseModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
						<p class="mb-1">Puedes enviar al cliente la solicitud para aprobar un requerimiento adicional al proyecto y así poder preparar los documentos necesarios (como por ejemplo un anexo de contrato).</p>
						<p class="mb-2">Esta solicitud para el proyecto <b>{{ projectInfo.project_name }}</b> será enviada al cliente <b>{{ projectInfo.project_client }}</b>. Y quedará a la espera de ser aprobada.</p>
						
						<p class="mb-2">A continuación puedes explicar al cliente por qué se necesita este requerimiento adicional.</p>
						<v-textarea
							v-model="messageToClient"
							label="Mensaje al cliente"
							placeholder="Escribe un mensaje para el cliente describiendo el requerimiento adicional..."
							outlined
							dense
							rows="3"
							:rules="requiredRule"
							class="mb-1"
						></v-textarea>
						<v-row class="mb-2">
							<v-col cols="8" class="py-0">
								<v-text-field
									v-model="estimatedAmount"
									label="Monto estimado"
									placeholder="Ingresa el monto estimado"
									outlined
									dense
									type="text"
									:rules="requiredRule"
									@input="sanitizeAmount"
									@keydown="blockInvalidCharsForAmount"
								></v-text-field>
							</v-col>
							<v-col cols="4" class="py-0">
								<v-select
									v-model="currencyType"
									:items="currencyOptions"
									label="Moneda"
									outlined
									dense
								></v-select>
							</v-col>
						</v-row>
						<div class="d-flex flex-row justify-end">
							<v-btn
								class="mx-2 my-1"
								color="white"
								raised
								@click="startCloseModal"
							>
								<p class="mb-0 text-primary">Cerrar</p>
							</v-btn>
							<v-btn
								class="mx-2 my-1"
								color="#524D4D"
								raised
								dark
								@click="confirmRequest"
							>
								<p class="mb-0">Confirmar y Enviar a Cliente</p>
							</v-btn>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import {createAdditionalRequest} from '@/helpers/api/projects'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
  name: 'AdditionalRequirementForProject',
  data: () => ({
		indexModal: + new Date(),
		messageToClient: '',
		estimatedAmount: null,
		currencyType: 1,
		currencyOptions: [{text: 'UF', value: 1}, {text: 'CLP', value: 2}],
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		projectInfo(){
			return this.$store.state.projects.projectAdditionalRequirementInfoModal
		}
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  watch: {
		currencyType() {
			this.estimatedAmount = null
		}
  },
  methods: {
		async confirmRequest(){
			const data = {
				project_id: this.projectInfo.project_id,
				description: this.messageToClient,
				estimated_amount: this.estimatedAmount,
				currency_type: this.currencyType
			}
			const additional = await createAdditionalRequest(data)
			if(additional.code == 200){
				eventBus.$emit('reloadInformation')
				this.setMessage({
					message: 'Solicitud de requerimiento adicional creada y enviada al cliente',
					title: 'Solicitud Enviada',
					type: 'success',
					icon: 'mdi-check',
					color: '#4CAF50'
				})
				
				this.$store.commit('projects/setAdditionalRequirementDetailModal', {
					additional_request_id: additional.additional_request.id,
				})
				this.startCloseModal(true)
			}
		},
		startCloseModal(add_reception = false){
			this.closeModal(add_reception)
		},
    closeModal(){
			this.$store.commit('projects/setProjectAdditionalRequirementInfoModal', null)
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		sanitizeAmount() {
			const isCLP = this.currencyType === 2
			let value = String(this.estimatedAmount || '')
			
			if (isCLP) {
				// Para CLP: solo números enteros
				value = value.replace(/\D/g, '').replace(/^0+(?!$)/, '') || '0'
			} else {
				// Para UF: permite un decimal
				const isNegative = value.startsWith('-')
				value = value
					.replace(/[^0-9.]/g, '')
					.replace(/^0+(?=\d)/, '')
				const parts = value.split('.')
				if (parts.length > 2) {
					value = parts[0] + '.' + parts.slice(1).join('')
				}
				if (isNegative && value !== '') {
					value = '-' + value
				}
				value = value || '0'
			}
			
			this.estimatedAmount = value
		},
		blockInvalidCharsForAmount(event) {
			const isCLP = this.currencyType === 2
			
			// Permitir navegación y edición
			const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
			if (allowedKeys.includes(event.key)) {
				return
			}
			
			// Permitir Ctrl/Cmd + A, C, X, Z, V
			if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'x', 'z', 'v'].includes(event.key.toLowerCase())) {
				return
			}
			
			const isDigit = /^[0-9]$/.test(event.key)
			const isPoint = event.key === '.'
			
			if (isCLP) {
				// CLP: solo dígitos
				if (!isDigit) {
					event.preventDefault()
				}
			} else {
				// UF: dígitos y máximo 1 punto
				if (isPoint) {
					// Si ya existe un punto, bloquear
					if (String(this.estimatedAmount).includes('.')) {
						event.preventDefault()
					}
				} else if (!isDigit) {
					event.preventDefault()
				}
			}
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>